import styled from 'styled-components';
import { Card } from '@mui/material';

export const Container = styled(Card)`
  padding: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  svg {
    margin-right: 1rem;
  }
`;
